// extracted by mini-css-extract-plugin
export default {"MenuItem":"_MenuItem--ZLfpo","Mobile":"_Mobile--ROl15","MenuItemText":"_MenuItemText--F1l00","WithIcon":"_WithIcon--zwhDV","Link":"_Link--PRGTc"};